export const SUCCESS_GET_ALL_SQL_QUERIES = 'SUCCESS_GET_ALL_SQL_QUERIES';
export const FAILED_GET_ALL_SQL_QUERIES = 'FAILED_GET_ALL_SQL_QUERIES';
export const SUCCESS_GET_SQL_QUERY = 'SUCCESS_GET_SQL_QUERY';
export const FAILED_GET_SQL_QUERY = 'FAILED_GET_SQL_QUERY';
export const SUCCESS_CREATE_SQL_QUERY = 'SUCCESS_CREATE_SQL_QUERY';
export const FAILED_CREATE_SQL_QUERY = 'FAILED_CREATE_SQL_QUERY';
export const SUCCESS_UPDATE_SQL_QUERY = 'SUCCESS_UPDATE_SQL_QUERY';
export const FAILED_UPDATE_SQL_QUERY = 'FAILED_UPDATE_SQL_QUERY';
export const SUCCESS_DELETE_SQL_QUERY = 'SUCCESS_DELETE_SQL_QUERY';
export const FAILED_DELETE_SQL_QUERY = 'FAILED_DELETE_SQL_QUERY';
export const SUCCESS_VALIDATE_SQL_QUERY = 'SUCCESS_VALIDATE_SQL_QUERY';
export const FAILED_VALIDATE_SQL_QUERY = 'FAILED_VALIDATE_SQL_QUERY';
export const SUCCESS_RERUNVALIDATE_SQL_QUERY = 'SUCCESS_RERUNVALIDATE_SQL_QUERY';
export const FAILED_RERUNVALIDATE_SQL_QUERY = 'FAILED_RERUNVALIDATE_SQL_QUERY';




// WEBPACK FOOTER //
// src/state/constants/sqlQueryConstants.js